export default __webpack_public_path__ + "static/media/gujarati.535420ae.svg";